import { Checkbox, Chip, useTheme } from '@mui/material';
import { TextField } from '@mui/material';
import { AutocompleteProps, createFilterOptions, default as MuiAutocomplete } from '@mui/material/Autocomplete';
import { useEffect, useRef, useState } from 'react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Box } from '@mui/material';
import { IconButton } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const translate = (key: string, values?: any) => (window as any).translate(key, values);

interface Props extends AutocompleteProps<undefined, undefined, undefined, undefined> {
  placeholder?: string;
  isValueArrayType?: boolean;
  showSelectAll?: boolean;
  error?: boolean;
  selectAllText?: string;
  readOnlyInput?: boolean;
}
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const Autocomplete = ({ placeholder, showSelectAll, ...props }: Props) => {
//   const theme = useTheme();
//   const [open, setOpen] = useState(false);
//   const allSelected = props.options.length === (Array.isArray(props?.value) ? (props?.value as any)?.length : 0);
//   const FieldallSelected =
//     Array.isArray(props?.value) && (props?.value as any)?.length > 0 ? props.options.length === (props?.value as any)?.length : false;
//   const anotherRef = useRef<HTMLDivElement | null>(null);
//   const filter = createFilterOptions();

//   const handleSelectAll = (event: any, reason: any, isSelected: boolean) => {
//     if (props.onChange) {
//       if (isSelected) {
//         props.onChange(event, props.options as any, reason);
//       } else {
//         props.onChange(event, [] as any, reason);
//       }
//     }
//   };
//   useEffect(() => {
//     if (allSelected && anotherRef.current) {
//       anotherRef.current?.blur();
//     }
//   }, [allSelected]);
//   const handleToggleSelectAll = (event: any, reason: string) => {
//     handleSelectAll && handleSelectAll(event, reason, !allSelected);
//   };

//   const handleChange = (event: any, selectedOptions: any, reason: any) => {
//     if (props.onChange) {
//       if (['selectOption', 'removeOption'].includes(reason)) {
//         if (selectedOptions.find((option: any) => option.id === 'select-all')) {
//           handleToggleSelectAll(event, reason);
//         } else {
//           props.onChange(event, selectedOptions, reason);
//         }
//       } else if (reason === 'clear') {
//         props.onChange(event, [] as any, reason);
//       }
//     }
//   };

//   return (
//     <MuiAutocomplete
//       sx={{
//         ...(props.error
//           ? {
//               '& .MuiOutlinedInput-root fieldset': {
//                 borderColor: theme.palette.error.main
//               }
//             }
//           : {})
//       }}
//       {...props}
//       open={props.disabled ? false : open}
//       onInputChange={(_event, _newInputValue, reason) => {
//         if (reason === 'clear') {
//           setOpen(true);
//         } else if (reason === 'reset') {
//           setOpen(false);
//         }
//       }}
//       onClose={(event, reason) => {
//       // Don't close on select-option to allow multiple selections
//       if (reason !== 'selectOption' && reason !== 'removeOption') {
//         setOpen(false);
//       }
//       }}
//       onOpen={() => setOpen(true)}
//       renderInput={(params) => (
//         <TextField
//           onFocus={() => setOpen(true)}
//           //onBlur={() => setOpen(false)}
//           placeholder={FieldallSelected ? '' : placeholder || 'Select'}
//           {...params}
//           inputRef={anotherRef}
//           inputProps={{
//             ...params.inputProps,
//             readOnly: props.readOnlyInput || false
//           }}
//         />
//       )}

      
//       isOptionEqualToValue={(option: any, value: any) => option?.label === value?.label}
//       {...(props.multiple
//         ? {
//             getOptionLabel: (option: any) => option.label,
//             renderOption: (props, option: any, { selected }) => {
//               const { key, ...optionProps } = props;
//               return (
//                 <li key={key} {...optionProps}>
//                   <Checkbox
//                     icon={icon}
//                     checkedIcon={checkedIcon}
//                     style={{ marginRight: 8 }}
//                     checked={option.id === 'select-all' ? allSelected : selected}
//                   />
//                   {option.label}
//                 </li>
//               );
//             },
//             filterOptions: (options, params: any) => {
//               const filtered = filter(options, params);
//               return [
//                 ...(showSelectAll && (props.options as any)?.length > 0
//                   ? [{ label: props.selectAllText || translate('elements.labels.selectAll'), id: 'select-all' }]
//                   : []),
//                 ...filtered
//               ] as any;
//             },
//             onChange: handleChange,
//             renderTags: (value, getTagProps) => (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   flexWrap: 'wrap',
//                   maxHeight: 'calc(3 * 38px)', // 3 rows (32px per row)
//                   overflow: 'auto',
//                   '&::-webkit-scrollbar': {
//                     width: '8px'
//                   },
//                   '&::-webkit-scrollbar-thumb': {
//                     backgroundColor: 'rgba(0,0,0,.2)',
//                     borderRadius: '3px'
//                   }
//                 }}
//               >
//                 {value.map((option, index) => {
//       const { key, ...tagProps } = getTagProps({ index });
//       return (
//         <Chip 
//           key={key}
//           label={option.label} 
//           {...tagProps} 
//         />
//       );
//     })}
//               </Box>
//             )
//           }
//         : {})}
//     />
//   );
// };

const Autocomplete = ({ placeholder, showSelectAll, ...props }: Props) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const allSelected = props.options.length === (Array.isArray(props?.value) ? (props?.value as any)?.length : 0);
  const hasAnySelected = Array.isArray(props?.value) && (props?.value as any)?.length > 0;
//  const FieldallSelected = hasAnySelected ? props.options.length === (props?.value as any)?.length : false;
 
  
  // const FieldallSelected =
  //   Array.isArray(props?.value) && (props?.value as any)?.length > 0 ? props.options.length === (props?.value as any)?.length : false;
  const anotherRef = useRef<HTMLDivElement | null>(null);
  const filter = createFilterOptions();

  const handleSelectAll = (event: any, reason: any, isSelected: boolean) => {
    if (props.onChange) {
      if (isSelected) {
        props.onChange(event, props.options as any, reason);
      } else {
        props.onChange(event, [] as any, reason);
      }
    }
  };

  useEffect(() => {
    if (allSelected && anotherRef.current) {
      anotherRef.current?.blur();
    }
  }, [allSelected]);

  const handleToggleSelectAll = (event: any, reason: string) => {
    handleSelectAll && handleSelectAll(event, reason, !allSelected);
  };

  const handleChange = (event: any, selectedOptions: any, reason: any) => {
    if (props.onChange) {
      if (['selectOption', 'removeOption'].includes(reason)) {
        if (selectedOptions.find((option: any) => option.id === 'select-all')) {
          handleToggleSelectAll(event, reason);
        } else {
          props.onChange(event, selectedOptions, reason);
        }
      } else if (reason === 'clear') {
        props.onChange(event, [] as any, reason);
      }
    }
  };

  const handleExpandToggle = () => {
    setExpanded(!expanded);
  };

  const renderCompactTags = (value: any[], getTagProps: any) => {
    const maxVisibleTags = 2;
    const visibleTags = expanded ? value : value.slice(0, maxVisibleTags);
    const hiddenCount = value.length - maxVisibleTags;

    return (
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 0.5,
          maxHeight: expanded ? 'calc(5 * 38px)' : 'calc(2 * 38px)',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
            borderRadius: '3px'
          }
        }}
      >
        {visibleTags.map((option, index) => {
          const originalIndex = expanded ? index : index;
          const { key, ...tagProps } = getTagProps({ index: originalIndex });
          return (
            <Chip 
              key={key}
              label={option.label} 
              {...tagProps}
              size="small"
            />
          );
        })}
        
        {!expanded && hiddenCount > 0 && (
          <Chip
            label={`+${hiddenCount} more`}
            size="small"
            variant="outlined"
            sx={{
              backgroundColor: theme.palette.action.hover,
              border: `1px dashed ${theme.palette.divider}`,
              '&:hover': {
                backgroundColor: theme.palette.action.selected,
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleExpandToggle();
            }}
          />
        )}
        
        {expanded && value.length > maxVisibleTags && (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleExpandToggle();
            }}
            sx={{
              ml: 0.5,
              padding: '2px',
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              }
            }}
          >
            <ExpandLessIcon fontSize="small" />
          </IconButton>
        )}
        
        {!expanded && value.length <= maxVisibleTags && value.length > 0 && (
          <Box sx={{ minWidth: '20px' }} /> // Spacer to maintain consistent layout
        )}
      </Box>
    );
  };

  return (
    <MuiAutocomplete
      sx={{
        ...(props.error
          ? {
              '& .MuiOutlinedInput-root fieldset': {
                borderColor: theme.palette.error.main
              }
            }
          : {})
      }}
      {...props}
      open={props.disabled ? false : open}
      onInputChange={(_event, _newInputValue, reason) => {
        if (reason === 'clear') {
          setOpen(true);
        } else if (reason === 'reset') {
          setOpen(false);
        }
      }}
      onClose={(event, reason) => {
        // Don't close on select-option to allow multiple selections
        if (reason !== 'selectOption' && reason !== 'removeOption') {
          setOpen(false);
        }
      }}
      onOpen={() => setOpen(true)}
      renderInput={(params) => (
        <TextField
          onFocus={() => setOpen(true)}
          //onBlur={() => setOpen(false)}
          placeholder={hasAnySelected ? '' : placeholder || 'Select'}
          {...params}
          inputRef={anotherRef}
          inputProps={{
            ...params.inputProps,
            readOnly: props.readOnlyInput || false
          }}
        />
      )}
      
      isOptionEqualToValue={(option: any, value: any) => option?.label === value?.label}
      {...(props.multiple
        ? {
            getOptionLabel: (option: any) => option.label,
            renderOption: (props, option: any, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={option.id === 'select-all' ? allSelected : selected}
                  />
                  {option.label}
                </li>
              );
            },
            filterOptions: (options, params: any) => {
              const filtered = filter(options, params);
              return [
                ...(showSelectAll && (props.options as any)?.length > 0
                  ? [{ label: props.selectAllText || translate('elements.labels.selectAll'), id: 'select-all' }]
                  : []),
                ...filtered
              ] as any;
            },
            onChange: handleChange,
            renderTags: renderCompactTags
          }
        : {})}
    />
  );
};

export default Autocomplete;
